let runtime = null

export function setRuntime(value) {
  runtime = value
}

export function getRuntime() {
  return runtime
}

export function createNuxtContext(route, vm) {
  const current = runtime || {}
  const app = current.app || (vm && vm.$app) || {}
  const router = current.router || (vm && vm.$router)
  const store = current.store || (vm && vm.$store)

  return {
    app,
    route,
    router,
    store,
    params: route.params || {},
    query: route.query || {},
    redirect(location) {
      return router && router.push(location)
    },
    error(err) {
      throw err
    }
  }
}
